/** Broker /broker add-credential response envelope for a discover-login
 * (COMPLEX_LOGIN) submit. Outer key `credentialValue` is camelCase (Go
 * CredentialResponse JSON tag); inner keys are snake_case. */
export interface BrokerCredentialResponse {
  credentialValue?: {
    job_id?: string;
    conversation_id?: string;
  };
}

/** Returns the spawned recorder conversation id, or null when none is present.
 * Pure + total — never throws on malformed input. */
export function readConversationId(response: unknown): string | null {
  const conv = (response as BrokerCredentialResponse | null | undefined)
    ?.credentialValue?.conversation_id;
  return typeof conv === 'string' && conv.length > 0 ? conv : null;
}
